import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../Demoseal.png';

const SideMenu = ({ userRoles }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      id: 'funding',
      label: 'Dashboard',
      to: '/dashboard',
      requiredRoles: ['Super Admin', 'Grant Manager', 'Internal Reviewer'],
      isActive: (pathname) => pathname === '/dashboard' || pathname.startsWith('/dashboard/new-application'),
    },
    {
      id: 'programs',
      label: 'Programs',
      to: '/dashboard/programs',
      requiredRoles: ['Super Admin', 'Grant Manager', 'Internal Reviewer'],
    },
    {
      id: 'laws',
      label: 'Laws & Policy',
      to: '/dashboard/laws',
      requiredRoles: ['Super Admin', 'Grant Manager', 'Internal Reviewer'],
    },
    {
      id: 'set-criteria',
      label: 'Set Criteria & Score',
      to: '/dashboard/set-criteria',
      requiredRoles: ['Super Admin', 'Grant Manager', 'Internal Reviewer'],
    },
    {
      id: 'review',
      label: 'Review Rounds',
      to: '/dashboard/review-rounds',
      requiredRoles: ['Internal Reviewer'],
    },
    {
      id: 'applications',
      label: 'Applications',
      to: '/dashboard/applications',
      requiredRoles: ['Super Admin', 'Grant Manager', 'Internal Reviewer'],
      isActive: (pathname) => pathname.startsWith('/dashboard/applications'),
    },
    {
      id: 'users',
      label: 'User Management',
      to: '/dashboard/users',
      requiredRoles: ['Super Admin'],
    },
  ];

  const handleSignOut = () => {
    localStorage.removeItem('token');
    navigate('/signin');
  };

  const canSeeItem = (item) => item.requiredRoles.some((role) => userRoles.includes(role));
  const visibleItems = menuItems.filter(canSeeItem);

  return (
    <div className="side-menu">
      <div className="side-menu-brand">
        <div className="side-menu-logo">
          <img src={logo} alt="NuGrants" />
        </div>
      </div>
      <nav className="side-menu-nav">
        {visibleItems.length > 0 ? (
          <ul className="side-menu-list">
            {visibleItems.map((item) => {
              const active = item.isActive
                ? item.isActive(location.pathname)
                : location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);

              return (
                <li key={item.id} className="side-menu-item">
                  <Link
                    to={item.to}
                    className={`side-menu-btn ${active ? 'active' : ''}`}
                    title={item.label}
                  >
                    <span className="menu-label">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="no-menu-items">No menu items available</p>
        )}
      </nav>
      <div className="side-menu-footer">
        <button className="side-menu-signout-btn" onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default SideMenu;
